import { render, staticRenderFns } from "./supplementaryInformation.vue?vue&type=template&id=20f07d09&scoped=true&"
import script from "./supplementaryInformation.vue?vue&type=script&lang=js&"
export * from "./supplementaryInformation.vue?vue&type=script&lang=js&"
import style0 from "./supplementaryInformation.vue?vue&type=style&index=0&id=20f07d09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f07d09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('20f07d09', component.options)
    } else {
      api.reload('20f07d09', component.options)
    }
    module.hot.accept("./supplementaryInformation.vue?vue&type=template&id=20f07d09&scoped=true&", function () {
      api.rerender('20f07d09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/supplementaryInformation.vue"
export default component.exports